import React, { useState } from 'react';

import { BackportingEnums } from '../../../generated/compat/backportingEnums';
import { Classifier } from '../../../generated/model/classifier';
import { CurrencyFilter } from '../../../generated/model/currencyFilter';
import { useDefaultValueWatcher } from '../../../hooks/useDefaultValueWatcher';
import { useOnChange } from '../../../hooks/useOnChange';
import InputDropdown from '../../Inputs/Dropdown/Dropdown';
import ReadableStatementView from '../../Inputs/ReadableStatementView';

interface Props {
  root?: boolean;
  active: boolean;
  defaultValue: CurrencyFilter;
  currencies: Classifier[];
  disabled?: boolean;
  onChange: (value: CurrencyFilter) => void;
}

const CurrencyFilterInput: React.FC<Props> = React.memo(
  ({ root, active, defaultValue, currencies, disabled = false, onChange }) => {
    const [state, setState] = useState(defaultValue);

    useDefaultValueWatcher({ defaultValue, state, setState });
    useOnChange(onChange, state, root);

    const rs: any[] = [];
    if (state?.value?.length) {
      rs.push({ label: 'Currency:', value: state.value });
    }

    const options = currencies.map((ccy) => ({
      label: ccy.name!!,
      value: ccy.id!!,
    }));

    return (
      <>
        {active ? (
          <div>
            <InputDropdown
              onChange={(value) => {
                setState({ ...state, value: value as BackportingEnums.CcyEnum });
              }}
              defaultValue={['' + defaultValue?.value]}
              label=""
              options={options}
              disabled={disabled}
            />
          </div>
        ) : (
          <ReadableStatementView rows={rs} />
        )}
      </>
    );
  },
);

export default CurrencyFilterInput;
